import React from 'react'
import Styled from "styled-components";
import ProjectHeading from '../components/ProjectHeading';
import ProjectsCardCont from '../components/ProjectsCardCont';

function Projects() {
  return (
    <MainCont>
      <ProjectHeading/>
      <ProjectsCardCont/>
    </MainCont>
  )
}
const MainCont = Styled.div`
    background:#111111;
    height:fit-content;
    display:flex;
    flex-direction:column;
    gap:4rem;
    padding-left:100px;
    padding-right:100px;
    overfow-x:hidden;
    animation:BottomToTop .9s ease-in-out;
    @media (max-width:768px){
      padding-bottom: 10vh;
      padding-left:10px;
      padding-right:10px;
      
    }
    @media (max-width:425px){
      gap:1rem;
    }
`;
export default Projects